var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnouncefillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(23748 23508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2680",
    "data-name": "Path 2680",
    d: "M12,2A10,10,0,1,1,2,12,10,10,0,0,1,12,2Zm0,18a8,8,0,1,0-8-8A7.989,7.989,0,0,0,12,20Zm0-2a6,6,0,1,1,6-6A5.992,5.992,0,0,1,12,18Zm0-8a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,10Z",
    transform: "translate(-23750 -23510)",
    fill: "#7c0e6f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncefillIcon);
export default __webpack_public_path__ + "static/media/announcefillIcon.72dd70c25f2395a131fe71f808021cae.svg";
export { ForwardRef as ReactComponent };